module.exports = __webpack_public_path__ + "assets/c7fe8483a4f201b7d519f2a83553abe3.png";